import { Link } from "react-router-dom";
import { Reveal, Overline } from "../Reveal";
import { MODULES } from "../../data/modules";
import { useI18n } from "../../i18n/I18nContext";

export const Pricing = () => {
  const { t, moduleText } = useI18n();
  return (
  <section id="tarifs" data-testid="pricing-section" className="py-28 md:py-40">
    <div className="max-w-7xl mx-auto px-6 md:px-10">
      <Reveal className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
        <div>
          <Overline>{t("pricing.overline")}</Overline>
          <h2 className="mt-6 font-serif text-4xl md:text-6xl tracking-tight text-ink leading-tight">
            {t("pricing.title")}
          </h2>
        </div>
        <p className="max-w-sm text-sm md:text-base leading-relaxed text-smoke">
          {t("pricing.sub")}
        </p>
      </Reveal>

      <div className="mt-16 md:mt-20">
        {MODULES.map((m, i) => (
          <Reveal key={m.id} delay={0.03 * i}>
            <div
              data-testid={`pricing-row-${m.id}`}
              className={`group grid grid-cols-12 items-center gap-4 px-4 md:px-8 py-6 md:py-8 border-b border-linen transition-colors duration-300 ${
                m.id === 5 ? "bg-bone rounded-2xl border-b-0 my-2" : "hover:bg-white"
              }`}
            >
              <span className="col-span-2 md:col-span-1 font-serif text-sm tracking-[0.3em] text-smoke/70">
                {String(m.id).padStart(2, "0")}
              </span>
              <div className="col-span-10 md:col-span-5">
                <span className="font-serif text-2xl md:text-3xl tracking-tight text-ink">{m.name}</span>
                {m.id === 5 && (
                  <span className="ml-3 text-[11px] uppercase tracking-[0.2em] text-sagedark align-middle">{t("pricing.mostChosen")}</span>
                )}
                <p className="text-xs md:text-sm text-smoke mt-1">{moduleText(m.id, "range", m.range)}</p>
              </div>
              <span className="col-span-6 md:col-span-3 text-sm text-smoke hidden md:block">{moduleText(m.id, "tagline", m.tagline)}</span>
              <div className="col-span-8 md:col-span-2">
                <span className="font-serif text-2xl md:text-3xl text-ink">{m.priceLabel}</span>
                {m.price > 0 && <span className="text-xs text-smoke"> {t("modules.perMonth")}</span>}
              </div>
              <div className="col-span-4 md:col-span-1 text-right">
                <Link
                  data-testid={`pricing-cta-${m.id}`}
                  to={`/connexion?mode=register&module=${m.id}`}
                  className="inline-flex rounded-full border border-ink/25 text-ink text-xs md:text-sm px-5 py-2.5 hover:bg-ink hover:text-paper transition-colors duration-300"
                >
                  {t("pricing.choose")}
                </Link>
              </div>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal className="mt-14">
        <div data-testid="partners-strip" className="rounded-3xl bg-bone px-8 md:px-12 py-10 flex flex-col md:flex-row md:items-center gap-6 md:gap-12">
          <p className="text-xs uppercase tracking-[0.25em] text-smoke shrink-0">{t("pricing.partnersOver")}</p>
          <p className="text-sm md:text-base text-smoke leading-relaxed">
            {t("pricing.partnersText1")} <span className="text-ink font-medium">{t("pricing.partnersBanks")}</span>, <span className="text-ink font-medium">{t("pricing.partnersMutuelles")}</span> {t("pricing.partnersText3")} <span className="text-ink font-medium">{t("pricing.partnersAssureurs")}</span> {t("pricing.partnersText4")}
          </p>
          <p className="md:ml-auto font-serif italic text-xl md:text-2xl text-sagedark shrink-0">
            {t("pricing.sponsor")}
          </p>
        </div>
      </Reveal>
    </div>
  </section>
  );
};
